import { MatterContactConnectionModalPreview } from "@/components/ui/MatterContactConnectionRichCard/MatterContactConnectionModalPreview";
import type {
  Connection,
  ConnectionContactPreview,
  Contact,
  MatterContactConnection,
} from "@/lib/types";
import { getConnectionPreviewContact } from "@/lib/utils/connections/item-contact-connections";

export function MedicalTreatmentContactPreview({
  contact,
  previewContact,
  connection,
  role,
  matterId,
  onRemoveContact,
}: {
  contact: Contact;
  previewContact?: ConnectionContactPreview | Contact;
  connection?: Connection;
  role: "Provider" | "Treating Physician";
  matterId: string;
  onRemoveContact?: () => void;
}) {
  const resolvedContact =
    (previewContact?.id === contact.id ? previewContact : undefined) ??
    (connection?.targetObjectId === contact.id
      ? getConnectionPreviewContact(connection)
      : undefined) ??
    contact;
  return (
    <MatterContactConnectionModalPreview
      contactId={contact.id}
      previewContact={
        Array.isArray(resolvedContact.phones) ? resolvedContact : undefined
      }
      fetchContactOnEdit
      matterId={matterId}
      visualVariant={role === "Treating Physician" ? "white" : undefined}
      matterContactConnection={
        (connection?.targetObjectId === contact.id
          ? connection
          : { label: role, contactId: contact.id }) as MatterContactConnection
      }
      onRemoveContact={onRemoveContact}
    />
  );
}
